export const authTypes = {
  AUTH_LOADING: "AUTH_LOADING",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_FAILURE: "AUTH_FAILURE",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  USER_DATA: "USER_DATA"
};
